// @flow

import React from 'react';
import CategoryAccordion from './categoryAccordion';
import type { ACFProps } from './types';

type Props = ACFProps;

const mapCategoryItems = faq_data => (
  faq_data.items.map(item => ({
    question: item.post_title,
    answer: item.post_content,
    id: item.ID,
  }))
);

const ACFCategoryAccordion = ({
  faq_data,
}: Props) => (
  <>
    { faq_data
      && <CategoryAccordion
        questions={mapCategoryItems(faq_data)}
      />}
  </>
);

export default ACFCategoryAccordion;
